import { useMemo } from 'react';
import { NumberParam, StringParam, useQueryParams, withDefault, } from 'use-query-params';
import debounce from 'modules/utils/debounce';
import { TeamDTO } from "modules/teams/domain/dtos/Team.dto";
import { useOrganizer } from 'modules/organizer/ui/hooks/useOrganizer';

const defaultFilters = {
  search: StringParam,
  page: withDefault(NumberParam, 1),
  perPage: withDefault(NumberParam, 5),
};

export const useTeamList = () => {
  const { info, isLoaded, isLoading } = useOrganizer();
  const [filters, setFilters] = useQueryParams(defaultFilters);

  const changeFilter = useMemo(() => debounce(
    (changes: { [key: string]: any }) => {
      setFilters({
        ...filters,
        ...changes,
      });
    }, 300),
    [filters, setFilters],
  );

  const { teams, pages } = useMemo(() => {
    if (!isLoaded || isLoading) {
      return {
        teams: [],
        pages: 0,
      };
    }

    const teams = (info?.teams || []).filter((team: TeamDTO) => {
      if (!filters.search) {
        return team;
      }

      const { name } = team;

      const includesSearch = (!filters.search || name.toLowerCase().includes(filters.search.toLowerCase()));

      return includesSearch;
    }) || [];

    const pages = Math.ceil(teams.length / filters.perPage);
    const offset = (filters.page - 1) * filters.perPage;
    const pageTeams = teams.slice(offset, offset + filters.perPage);

    return {
      teams: pageTeams,
      pages,
    };

  }, [info?.teams, isLoading, isLoaded, filters]);

  return {
    changeFilter,
    filters,
    teams,
    isLoading,
    pages,
  };
};
